<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill" *ngIf="timeEntries">
        <dx-data-grid
            #dataGrid
            [dataSource]="timeEntries"
            keyExpr="id"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onOptionChanged)="onOptionChanged($event)"
            (onContentReady)="onContentReady($event)"
        >
            <dxi-column dataField="job.jobNumber" caption="Job #" width="80"></dxi-column>
            <dxi-column dataField="job.customerName" caption="Customer" width="200"></dxi-column>
            <dxi-column dataField="job.description" caption="Job Desc." width="200"></dxi-column>
            <dxi-column dataField="employee.displayName" caption="Employee" width="200"></dxi-column>
            <dxi-column dataField="description" caption="Employee Notes" width="200"></dxi-column>
            <dxi-column dataField="timeCategory.name" caption="Type" width="200"></dxi-column>
            <dxi-column dataField="quantity" width="100"></dxi-column>
            <dxi-column dataField="created" caption="Create Date" width="100"></dxi-column>
            <dxi-column dataField="" width="100"></dxi-column>

            <dxo-remote-operations [sorting]="true" [paging]="true" [filtering]="true"></dxo-remote-operations>
            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-group-panel [visible]="true"></dxo-group-panel>
            <dxo-summary>
                <dxi-group-item column="Quantity" summaryType="sum" [showInGroupFooter]="true" [alignByColumn]="true" displayFormat="Sum: {0}"> </dxi-group-item>
            </dxo-summary>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="time-search-grid"></dxo-state-storing>
            <dxo-selection [mode]="'multiple'"></dxo-selection>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button type="button" class="btn btn-warning ml-2" (click)="toggleShowAll()">{{showAll ? 'Show Recent' : 'Show All'}}</button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="timeEntries" class="mr-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
